// extracted by mini-css-extract-plugin
export var promotionLink = "_wl-0";